import { RouterSelectors } from '@next/core-lib/router-store';
import { createSelector } from '@ngrx/store';

import { getSelectedCycle } from './cycle.selectors';
import {
  sumAmountOfChicksExcludeCurrentDayOldChick,
  sumAmountOfChicksByBarn,
} from './day-old-chick.selectors';
import { Departure } from '../../models/cycle.model';

export const getDepartures = createSelector(getSelectedCycle, (cycle) =>
  !!cycle && !!cycle.departures
    ? cycle.departures.slice().sort((a, b) => (a.departureDate > b.departureDate ? 1 : -1))
    : [],
);

export const getNextDepartureId = createSelector(getDepartures, (departures) =>
  !!departures && departures.length > 0 ? Math.max(...departures.map((d) => d.id)) + 1 : 1,
);

export const getSelectedDepartureId = createSelector(RouterSelectors.getMergedRoute, (state) =>
  !isNaN(parseInt(state.params['departureId'], 10))
    ? parseInt(state.params['departureId'], 10)
    : undefined,
);

export const getSelectedDeparture = createSelector(
  getSelectedDepartureId,
  getDepartures,
  (departureId: number, departures: Departure[]) =>
    departures ? departures.find((d) => d.id === departureId) : undefined,
);

export const getChicksRemaining = createSelector(
  getDepartures,
  getSelectedDepartureId,
  sumAmountOfChicksByBarn,
  (departures, selectedDepartureId, getAmounyByBarn) => (barnId: number) =>
    barnId
      ? !!departures && departures.length > 0
        ? departures.reduce(
            (a, d) =>
              d.id !== selectedDepartureId && d.barn.id === barnId ? a - d.amountOfChicks : a,
            getAmounyByBarn(barnId),
          )
        : getAmounyByBarn(barnId)
      : 0,
);

export const departureChicksAmount = createSelector(
  getDepartures,
  sumAmountOfChicksExcludeCurrentDayOldChick,
  (departures, totalAmountExcludeCurrentDayOldChick) => (barnId: number) =>
    departures.reduce(
      (acc: number, d: Departure) => (d.barn.id === barnId ? acc + d.amountOfChicks : acc),
      -totalAmountExcludeCurrentDayOldChick(barnId),
    ),
);
